// Device management.js
import React from "react";
// import CompanyApplicationsTable from './Components/CompanyApplicationsTable';
import SimplePageHeader from "./Components/Navigation/SimplePageHeader";
import InfoBanner from "./Components/Navigation/InfoBanner";

function DeviceManagement() {
  // const [searchTerm, setSearchTerm] = useState("");

  // const handleSearchChange = (term) => {
  //   setSearchTerm(term);
  // };

  return (
    <>
      <SimplePageHeader
        iconName="devices"
        pageType="devices"
        placeholderText="Search by Device name only"
        titleString={"Manage Devices"}
        //onSearchChange={handleSearchChange}
        showAddButton={true}
      />
      <InfoBanner
        message={
          "This page can be used to configure deployment settings for individual devices.\nIf a device is defined here the settings will apply rather those defined at company level."
        }
        localStorageKey="device-management-page" // Unique key for this page
      />

      <div style={{ padding: "0 20px 20px 20px" }}>

      </div>
    </>
  );
}

export default DeviceManagement;
